import { render, staticRenderFns } from "./VehiculesListSortis.vue?vue&type=template&id=055fabc4&scoped=true&"
import script from "./VehiculesListSortis.vue?vue&type=script&lang=js&"
export * from "./VehiculesListSortis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055fabc4",
  null
  
)

export default component.exports